import { useTheme } from "../../../hooks/useTheme";
import { CSSProperties } from "react";
import { Colors } from "../../../utils/colors";
import { Icon } from "@iconify/react";
import { DMAutomationPlatform } from "@markit/common.types";

type SocialPlatformIconItemProps = {
  platform: DMAutomationPlatform;
  size?: number;
  noBorder?: boolean;
  containerStyles?: CSSProperties;
};

const PLATFORM_ICON: Record<DMAutomationPlatform, string> = {
  [DMAutomationPlatform.INSTAGRAM]: "skill-icons:instagram",
  [DMAutomationPlatform.FACEBOOK]: "selfhst:facebook-messenger",
};

// Displays a platform icon for Instagram or Facebook
export const SocialPlatformIconItem = ({
  platform,
  size,
  noBorder,
  containerStyles,
}: SocialPlatformIconItemProps) => {
  const { theme } = useTheme();
  const icon = PLATFORM_ICON[platform];

  return noBorder ? (
    <Icon icon={icon} height={size || 22} style={{ flexShrink: 0 }} />
  ) : (
    <div
      className="Centering"
      style={{
        backgroundColor: Colors.WHITE1,
        border: `1.5px solid ${theme.DividerColor.borderColor}`,
        borderRadius: 8,
        width: size || 37,
        height: size || 37,
        flexShrink: 0,
        ...containerStyles,
      }}
    >
      <Icon icon={icon} height={size ? size / 1.7 : 22} />
    </div>
  );
};
